import React, { useContext } from 'react';
import EditSessionContext from './EditSessionContext';
import { PanelButton } from '../../controls/PanelButtons';
import AddContext from '../../utils/AddMode/AddContext';
import useTranslation from '../../utils/Translations/useTranslation';
import Spinner from '../../utils/Spinner';
const EditSessionButton = ({ isCreating = false, className = '', spinnerClassName = '', hasWrapper = false, isDisabled = false, }) => {
    const { t } = useTranslation();
    const { isAddMode } = useContext(AddContext);
    const { loading, isEditSessionActive, isEditSessionLocked, cancelEditSession, beginEditSession, } = useContext(EditSessionContext);
    if ((hasWrapper && isCreating) || isAddMode || isEditSessionLocked) {
        return null;
    }
    if (loading) {
        return <Spinner className={spinnerClassName}/>;
    }
    return (<PanelButton className={className} dataCy="edit-session-toggle-button" hasWrapper={hasWrapper} icon={isEditSessionActive ? 'eye' : 'pencil7'} isDisabled={isDisabled} title={isEditSessionActive ? t('View Mode') : t('Edit Mode')} onClick={isEditSessionActive ? cancelEditSession : beginEditSession}/>);
};
export default EditSessionButton;
